
// src/reducers/sessions-reducer.js

import { mergeArray, deleteArray } from '../helpers/store'
import AccessToken from '../actions/access-token'

import { 
  LOGIN,
  LOGIN_REQUESTED,
  LOGIN_COMPLETED,
  LOGIN_FAILED,
  CLEAR_LOGIN_STATUS,
  LOGOUT,
  LOGOUT_REQUESTED,
  LOGOUT_COMPLETED,
  LOGOUT_FAILED,
  CHECK_LOGIN_STATUS,
  CHECK_LOGIN_STATUS_COMPLETED,
  CHECK_LOGIN_STATUS_REQUESTED,
} from '../actions/sessions'

import {
  FETCH_CURRENT_USER_FAILED,
  UPDATE_PASSWORD_COMPLETED,
} from '../actions/user'

var initialState = {
  isFetching: false,
  login: false,
  access_token: undefined,
  isFailed: false,
}
AccessToken.get((token)=> {
  initialState.login = !!token
  initialState.access_token = token
})

export default function sessionsReducer(state = initialState, action = {}) {
  switch(action.type) {
  case LOGIN_REQUESTED:
  case LOGOUT_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
    })

  case LOGIN_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFailed: true,
    })

  case LOGOUT_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case LOGIN_COMPLETED:
    if (action.results.access_token)
      return Object.assign({}, state, {
        isFetching: false,
        isFailed: false,
        login: true,
        access_token: action.results.access_token,
        password_change_required: undefined,
        password_required: undefined,
        passcode_required: undefined,
        sso_required: undefined,
        sso_url: undefined,
      })
    else
      return Object.assign({}, state, {
        isFetching: false,
        isFailed: false,
        password_required: action.results.password_required,
        passcode_required: action.results.passcode_required,
        password_change_required: action.results.password_change_required,
        sso_required: action.results.sso_required,
        sso_url: action.results.sso_url,
      })

  case CLEAR_LOGIN_STATUS:
    return Object.assign({}, state, {
      isFetching: false,
      isFailed: false,
      password_change_required: undefined,
      password_required: undefined,
      passcode_required: undefined,
      sso_required: undefined,
      sso_url: undefined,
    })

  case UPDATE_PASSWORD_COMPLETED:
    return Object.assign({}, state, {
      access_token: action.results.access_token,
    })

  case LOGOUT_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      login: false,
      access_token: undefined,
    })

  case CHECK_LOGIN_STATUS_COMPLETED:
    return Object.assign({}, state, {
      isChecking: false,
      login: action.access_token ? true : false,
      access_token: action.access_token,
    })

  case CHECK_LOGIN_STATUS_REQUESTED:
    return Object.assign({}, state, {
      isChecking: true,
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/sessions-reducer.js